/**
 * Official PawLink support email — used across every support/help/contact touchpoint.
 * Never display or link to any other email address. Update in ONE place; propagates app-wide.
 */
export const SUPPORT_EMAIL = "Support@getpawlink.com";

/** Human-readable subject line pre-populated in every support link. */
export const SUPPORT_SUBJECT = "PawLink Support Request";

/**
 * Return the INTERNAL PawLink support page URL. Historically this returned a
 * `mailto:` URL, but that opens the OS email chooser (Outlook / Gmail /
 * Yahoo picker) and pushes users out of PawLink — a release-blocker per the
 * product spec. Every "Contact us / Help / Support" link in the app now
 * navigates to the built-in Support Center at `/support`, where the user
 * fills a form that is delivered to Support@getpawlink.com by the backend.
 *
 * The optional `subject` argument is preserved as a URL query parameter so
 * the Support page can pre-fill the subject field.
 */
export function supportMailto({ subject = SUPPORT_SUBJECT } = {}) {
    const params = new URLSearchParams();
    if (subject && subject !== SUPPORT_SUBJECT) params.set("subject", subject);
    const qs = params.toString();
    return qs ? `/support?${qs}` : "/support";
}
